import { createAction } from '@reduxjs/toolkit';
export const ATTEMPT_RECONNECT = 'ATTEMPT_RECONNECT';
export const attemptReconnectAction = createAction(ATTEMPT_RECONNECT);